<div class="header-dialog">
  <div *ngIf="data.mode === 'add'" class="titre">
    <mat-icon fontIcon="add"></mat-icon>
    <span>{{ 'actions.add' | translate }}</span>
  </div>

  <div *ngIf="data.mode === 'edit'" class="titre">
    <mat-icon fontIcon="edit"></mat-icon>
    <span>{{ 'actions.edit' | translate }}</span>
  </div>

  <lib-button (click)="close()" icon="close" color="none" textColor="muted"></lib-button>
</div>

<mat-tab-group>
  <mat-tab label="{{ 'actions.tab.details' | translate }}">
    <form class="action-form" (submit)="save()">
      <div class="form-row">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ 'actions.field.title' | translate }}</mat-label>
          <input type="text" matInput [(ngModel)]="action.title" name="title" required>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ 'actions.field.description' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="action.description" name="description" rows="3"></textarea>
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.type' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.type" name="type">
            <mat-option *ngFor="let t of typeOptions" [value]="t">
              {{ 'actions.type.' + t | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.priority' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.priority" name="priority">
            <mat-option *ngFor="let p of priorityOptions" [value]="p">
              {{ 'actions.priority.' + p | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.status' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.status" name="status">
            <mat-option *ngFor="let s of statusOptions" [value]="s">
              {{ 'actions.status.' + s | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="isStatusChanged()" class="form-row status-change-note">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>{{ 'actions.status_change_comment' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="statusChangeComment" name="statusChangeComment" rows="2"></textarea>
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.assignee' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.assignee" name="assignee">
            <mat-option [value]="null">{{ 'form.none' | translate }}</mat-option>
            <mat-option *ngFor="let u of users" [value]="u.id">
              {{ u.firstName }} {{ u.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.dueDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="duePicker" [(ngModel)]="action.dueDate" name="dueDate">
          <mat-datepicker-toggle matSuffix [for]="duePicker"></mat-datepicker-toggle>
          <mat-datepicker #duePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.completionDate' | translate }}</mat-label>
          <input matInput [matDatepicker]="donePicker" [(ngModel)]="action.completionDate" name="completionDate">
          <mat-datepicker-toggle matSuffix [for]="donePicker"></mat-datepicker-toggle>
          <mat-datepicker #donePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="form-column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.risk' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.risks" name="risks" multiple>
            <mat-option *ngFor="let r of risks" [value]="r.id">
              {{ r.payload.title }} — {{ r.createdDate | timeFormat: 'dd/MM/yyyy' }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.source' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.source" name="source">
            <mat-option *ngFor="let s of sourceOptions" [value]="s">
              {{ 'actions.source.' + s | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <div class="form-column">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'actions.field.effectiveness' | translate }}</mat-label>
          <mat-select [(ngModel)]="action.effectiveness" name="effectiveness">
            <mat-option [value]="null">{{ 'form.none' | translate }}</mat-option>
            <mat-option *ngFor="let e of effectivenessOptions" [value]="e">
              {{ 'actions.effectiveness.' + e | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="grow-2">
          <mat-label>{{ 'actions.field.effectivenessNote' | translate }}</mat-label>
          <input matInput [(ngModel)]="action.effectivenessNote" name="effectivenessNote">
        </mat-form-field>
      </div>

      <mat-dialog-actions class="actions">
        <lib-button (click)="close()" color="outline" icon="close" text="{{ 'viewer.close' | translate }}">
        </lib-button>
        <lib-button color="primary" text="{{ 'viewer.save' | translate }}" type="submit" icon="save" [loading]="saving">
        </lib-button>
      </mat-dialog-actions>
    </form>
  </mat-tab>

  <mat-tab *ngIf="data.mode === 'edit'" label="{{ 'actions.tab.history' | translate }}">
    <div class="history-list">
      <div *ngIf="!action.statusHistory?.length" class="no-history">
        <mat-icon fontIcon="history"></mat-icon>
        <span>{{ 'actions.no_history' | translate }}</span>
      </div>

      <div *ngFor="let h of action.statusHistory" class="history-item">
        <div class="history-row">
          <mat-icon fontIcon="flag" class="history-icon"></mat-icon>
          <span class="history-status">{{ 'actions.status.' + h.status | translate }}</span>
          <span class="history-meta">
            {{ h.changedAt | timeFormat: 'dd/MM/yyyy HH:mm' }}
            <ng-container *ngIf="h.changedByName"> — {{ h.changedByName }}</ng-container>
          </span>
        </div>
        <div *ngIf="h.comment" class="history-comment">{{ h.comment }}</div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
